import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend"; // for loading from external URL

i18n
  .use(HttpBackend) // use backend loader
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "https://storage.googleapis.com/gamerji-uploads/languages/gj-st/{{lng}}.json",   
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
